













































































import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
import { DxPopup } from "devextreme-vue";
import DxSelectBox from "devextreme-vue/select-box";
import DxTagBox from "devextreme-vue/tag-box";
import DxButton from "devextreme-vue/button";
import UserAccessService from "@/services/user_access_service";
import NotifyService from "@/services/notify_service";
import RoleService from '@/services/data/role_manager';

@Component({
  name: "popupDistributeAccessRights",
  components: {
    DxPopup,
    DxSelectBox,
    DxTagBox,
    DxButton
  }
})
export default class extends Vue {
  @PropSync('popupOptions') public localPopupOptions: any;
  @Prop({ type: Array, default: () => [] }) readonly filialWithUsers!: any[];
  @Prop({ type: Array, default: () => [] }) readonly allUsers!: any[];

  public selectedFilialId: number | null = null;
  public selectedUserId: string | null = null;
  public selectedTargetUserIds: string[] = [];

  public filteredUsers: any[] = [];
  public filteredUsersExcludingSelected: any[] = [];

  public userAccessService = UserAccessService;

  public roleService = RoleService;

  @Watch('allUsers', { immediate: true })
  onAllUsersChanged() {
    if (this.selectedFilialId) {
      const selectedFilial = this.filialWithUsers.find(f => f.filial_id === this.selectedFilialId);
      if (selectedFilial) {
        const userIds = selectedFilial.users_id;
        this.filteredUsers = this.allUsers.filter(u => userIds.includes(u.id));

        // Если уже выбран пользователь — обновляем filteredUsersExcludingSelected
        if (this.selectedUserId) {
          this.filteredUsersExcludingSelected = this.filteredUsers.filter(u => u.id !== this.selectedUserId);
        }
      } else {
        this.filteredUsers = [];
        this.filteredUsersExcludingSelected = [];
      }
    }
  }

  onShowing() {
    this.selectedFilialId = null;
    this.selectedUserId = null;
    this.selectedTargetUserIds = [];
    this.filteredUsers = [];
    this.filteredUsersExcludingSelected = [];
  }

  onClose() {
    this.selectedFilialId = null;
    this.selectedUserId = null;
    this.selectedTargetUserIds = [];
    this.filteredUsers = [];
    this.filteredUsersExcludingSelected = [];
    this.localPopupOptions.visible = false;
  }

  onFilialChanged(e: any) {
    const selectedId = e.value;
    const selectedFilial = this.filialWithUsers.find(f => f.filial_id === selectedId);
    if (selectedFilial) {
      const userIds = selectedFilial.users_id;
      const adminRoleId = this.roleService.roles.find((i: any) => i.description === 'Администратор')?.id;
      this.filteredUsers = this.allUsers.filter((u: any) => {
           return userIds.includes(u.id) || u.role === adminRoleId
      });
    } else {
      this.filteredUsers = [];
    }
    this.selectedUserId = null;
    this.selectedTargetUserIds = [];
    this.filteredUsersExcludingSelected = [];
  }

  onUserChanged(e: any) {
    const selectedId = e.value;
    this.filteredUsersExcludingSelected = this.filteredUsers.filter(user => user.id !== selectedId);
    this.selectedTargetUserIds = [];
  }

  async onCopy() {
    if (!this.selectedUserId || !this.selectedTargetUserIds.length || !this.selectedFilialId) {
      NotifyService.error("Выберите пользователя и получателей для распространения прав.");
      return;
    }

    try {
      const result = await this.userAccessService.multy_copy(this.selectedUserId, this.selectedTargetUserIds, this.selectedFilialId);
      if (result) {
        NotifyService.success("Права успешно распространены.");
      } else {
        throw new Error("Ошибка на сервере");
      }
    } catch (error) {
      console.log(error)
      NotifyService.error("Ошибка при копировании прав доступа.");
    } finally {
      this.onClose();
    }
  }
}
